import { render, staticRenderFns } from "./ProductStandardSummary.vue?vue&type=template&id=378ed1eb&"
import script from "./ProductStandardSummary.vue?vue&type=script&lang=js&"
export * from "./ProductStandardSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports